module.exports = __webpack_public_path__ + "media/icons/widget-carq-badge-21a25b90.png";